<template>
    <div class="effective-list">
      <!-- 搜索和筛选 -->
      <el-form :inline="true" class="search-form" size="small">
        <el-form-item label="项目名称">
          <el-input
            v-model="searchForm.workName"
            placeholder="搜索项目名称"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
        <el-form-item label="申请人">
          <el-input
            v-model="searchForm.applyUser"
            placeholder="搜索申请人ID"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
        <el-form-item label="生效时间">
          <el-date-picker
            v-model="searchForm.effectDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            @change="handleSearch"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" :loading="loading">
            搜索
          </el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
  
      <!-- 申请列表 -->
      <el-table
        :data="applyList"
        border
        v-loading="loading"
        class="apply-table"
        @sort-change="handleSortChange"
      >
        <el-table-column prop="id" label="申请ID" width="80" sortable="custom" />
        <el-table-column prop="WorkName" label="项目名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="build_company" label="建设单位" min-width="120" show-overflow-tooltip />
        <el-table-column label="修改内容" min-width="100">
          <template slot-scope="scope">
            <el-tag size="small" type="success">
              已生效{{ scope.row.changedCount || 0 }}项
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="applyUserName" label="申请人" width="100">
          <template slot-scope="scope">
            {{ scope.row.applyUserName || '用户' + scope.row.apply_user_id }}
          </template>
        </el-table-column>
        <el-table-column prop="apply_time" label="申请时间" width="150" sortable="custom">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.apply_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="review_user_id" label="审批人" width="100">
          <template slot-scope="scope">
            {{ scope.row.review_user_id ? '用户' + scope.row.review_user_id : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="review_time" label="审批时间" width="150">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.review_time) }}
          </template>
        </el-table-column>
        <el-table-column label="生效时间" width="150">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.update_time || scope.row.review_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleViewDetail(scope.row)"
            >
              查看详情
            </el-button>
            <el-button
              type="text"
              size="mini"
              style="color: #409EFF"
              @click="handleViewContract(scope.row)"
            >
              查看合同
            </el-button>
            <el-button
              v-if="roleId == 1"
              type="text"
              size="mini"
              style="color: #909399"
              @click="handleViewHistory(scope.row)"
            >
              历史记录
            </el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        class="pagination"
      />
  
      <!-- 统计信息 -->
      <el-card class="stat-card" v-if="applyList.length > 0">
        <div slot="header" class="stat-header">
          <span>统计信息</span>
        </div>
        <div class="stat-content">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-label">总生效数</div>
                <div class="stat-value">{{ applyList.length }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-label">今日生效</div>
                <div class="stat-value">{{ todayEffectCount }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-label">本周生效</div>
                <div class="stat-value">{{ weekEffectCount }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-label">本月生效</div>
                <div class="stat-value">{{ monthEffectCount }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
  import { getContractApplyList } from '../api';
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'EffectiveList',
    
    data() {
      return {
        loading: false,
        applyList: [],
        
        // 搜索表单
        searchForm: {
          workName: '',
          applyUser: '',
          effectDateRange: []
        },
        
        // 分页
        pagination: {
          current: 1,
          size: 10,
          total: 0
        },
        
        // 排序
        sortField: 'update_time',
        sortOrder: 'desc',
        
        // 统计
        todayEffectCount: 0,
        weekEffectCount: 0,
        monthEffectCount: 0
      };
    },
    
    computed: {
      ...mapGetters(['roleId'])
    },
    
    created() {
      this.loadData();
    },
    
    methods: {
      // 加载数据
      async loadData() {
        this.loading = true;
        try {
          const params = {
            page: this.pagination.current,
            limit: this.pagination.size,
            status: 1, // 已通过状态
            isEffective: 1, // 已生效
            roleId: this.roleId
          };
          
          // 添加搜索条件
          if (this.searchForm.workName) {
            params.workName = this.searchForm.workName;
          }
          if (this.searchForm.applyUser) {
            params.applyUser = this.searchForm.applyUser;
          }
          
          // 添加生效时间范围
          if (this.searchForm.effectDateRange && this.searchForm.effectDateRange.length === 2) {
            params.startDate = this.searchForm.effectDateRange[0];
            params.endDate = this.searchForm.effectDateRange[1];
          }
          
          // 添加排序
          if (this.sortField) {
            params.field = this.sortField;
            params.order = this.sortOrder;
          }
          
          const res = await getContractApplyList(params);
          
          if (res.code === 0) {
            this.applyList = res.data || [];
            this.pagination.total = res.count || 0;
            
            // 计算统计信息
            this.calculateStatistics();
          } else {
            this.$message.error(res.msg || '加载失败');
          }
        } catch (error) {
          console.error('加载已生效列表失败:', error);
          this.$message.error('加载失败');
        } finally {
          this.loading = false;
        }
      },
      
      // 计算统计信息
      calculateStatistics() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const weekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        const monthAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
        
        this.todayEffectCount = 0;
        this.weekEffectCount = 0;
        this.monthEffectCount = 0;
        
        this.applyList.forEach(apply => {
          const effectTime = apply.update_time || apply.review_time;
          if (!effectTime) return;
          
          const effectDate = new Date(effectTime);
          
          if (effectDate >= today) {
            this.todayEffectCount++;
          }
          if (effectDate >= weekAgo) {
            this.weekEffectCount++;
          }
          if (effectDate >= monthAgo) {
            this.monthEffectCount++;
          }
        });
      },
      
      // 搜索
      handleSearch() {
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 重置搜索
      resetSearch() {
        this.searchForm = {
          workName: '',
          applyUser: '',
          effectDateRange: []
        };
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 排序变化
      handleSortChange({ prop, order }) {
        if (prop && order) {
          this.sortField = prop;
          this.sortOrder = order === 'ascending' ? 'asc' : 'desc';
        } else {
          this.sortField = 'update_time';
          this.sortOrder = 'desc';
        }
        this.loadData();
      },
      
      // 分页大小变化
      handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 当前页变化
      handleCurrentChange(current) {
        this.pagination.current = current;
        this.loadData();
      },
      
      // 查看详情
      handleViewDetail(row) {
        this.$emit('show-detail', {
          applyId: row.id,
          canApprove: false,
        });
      },
      
      // 查看合同
      handleViewContract(row) {
        this.$router.push({
          path: '/yj/work',
          query: { 
            highlightId: row.contract_id,
            view: 'detail'
          }
        });
      },
      
      // 查看历史记录
      handleViewHistory(row) {
        this.$message.info('历史记录功能暂未实现');
        // 这里可以跳转到修改历史页面
        // this.$router.push({
        //   path: '/yj/contract/history',
        //   query: { contractId: row.contract_id }
        // });
      },
      
      // 格式化日期时间
      formatDateTime(datetime) {
        if (!datetime) return '-';
        const date = new Date(datetime);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
      }
    }
  };
  </script>
  
  <style scoped>
  .effective-list {
    padding: 10px;
  }
  
  .search-form {
    margin-bottom: 15px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  
  .apply-table {
    margin-bottom: 15px;
    font-size: 13px;
  }
  
  .pagination {
    text-align: right;
    padding: 10px 0;
  }
  
  .stat-card {
    margin-top: 20px;
  }
  
  .stat-header {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }
  
  .stat-content {
    padding: 10px 0;
  }
  
  .stat-item {
    text-align: center;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  
  .stat-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 5px;
  }
  
  .stat-value {
    font-size: 24px;
    font-weight: 600;
    color: #409EFF;
  }
  
  /* 响应式适配 */
  @media screen and (max-width: 768px) {
    .search-form {
      padding: 10px;
    }
    
    .apply-table {
      font-size: 12px;
    }
    
    ::v-deep .el-table__cell {
      padding: 4px 0;
    }
    
    ::v-deep .el-button--mini {
      padding: 4px 8px;
      font-size: 12px;
    }
    
    .stat-item {
      padding: 8px 4px;
    }
    
    .stat-value {
      font-size: 18px;
    }
  }
  </style>